import React from "react";

import AuthPage from "./AuthPage";

const Login = () => <AuthPage />;

export default Login;
